export function createDebounceFn(ms) {
    let timerId;
    return function debounce(fn, ...args) {
        clearTimeout(timerId);
        timerId = setTimeout(() => fn(...args), ms);
    };
}
export function getTotalPages(listLenght, pageSize) {
    return Math.ceil(listLenght / pageSize);
}
export function getTotalScroll(listLenght, elementNumber) {
    return Math.floor(listLenght / elementNumber);
}
